<!-- ModalHeader.vue -->
<!-- Cabeçalho reutilizável de modal: título + botão de fechar. -->
<template>
  <h1 class="modal-title fs-5">{{ title }}</h1>
  <button
    type="button"
    class="btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
    @click="$emit('close')"
  ></button>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: ''
  }
})

defineEmits(['close'])
</script>
